import { pageResolver } from '@/core/component-resolver.service';
import StoreContextContentPage from './StoreContextContentPage.vue';

// Content pages
pageResolver.register('StoreContextContentPageViewModel', StoreContextContentPage);
